/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  ProductDraftsUserControllerUpdateMutationRequest,
  ProductDraftsUserControllerUpdateMutationResponse,
  ProductDraftsUserControllerUpdatePathParams,
  ProductDraftsUserControllerUpdate400,
  ProductDraftsUserControllerUpdate401,
  ProductDraftsUserControllerUpdate404,
  ProductDraftsUserControllerUpdate409,
} from '../../types/ProductDraftsUserControllerUpdate.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { productDraftsUserUpdate } from '../../methods/productDraftsUserUpdate.ts';
import { useMutation } from '@tanstack/react-query';

export const productDraftsUserUpdateMutationKey = () => [{ url: '/api/user/product-drafts/:id' }] as const;

export type ProductDraftsUserUpdateMutationKey = ReturnType<typeof productDraftsUserUpdateMutationKey>;

/**
 * {@link /api/user/product-drafts/:id}
 */
export function useProductDraftsUserUpdate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ProductDraftsUserControllerUpdateMutationResponse,
      ResponseErrorConfig<
        | ProductDraftsUserControllerUpdate400
        | ProductDraftsUserControllerUpdate401
        | ProductDraftsUserControllerUpdate404
        | ProductDraftsUserControllerUpdate409
      >,
      { id: ProductDraftsUserControllerUpdatePathParams['id']; data: ProductDraftsUserControllerUpdateMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<ProductDraftsUserControllerUpdateMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? productDraftsUserUpdateMutationKey();

  return useMutation<
    ProductDraftsUserControllerUpdateMutationResponse,
    ResponseErrorConfig<
      | ProductDraftsUserControllerUpdate400
      | ProductDraftsUserControllerUpdate401
      | ProductDraftsUserControllerUpdate404
      | ProductDraftsUserControllerUpdate409
    >,
    { id: ProductDraftsUserControllerUpdatePathParams['id']; data: ProductDraftsUserControllerUpdateMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return productDraftsUserUpdate(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
